<template>
    <div v-if="$root.isMobile" class="mobile-page-title">
        <div class="d-flex justify-content-between align-items-center">
            <button type="button" class="btn btn-primary btn-sm" @click="showFilters = true">
                <i class="fal fa-sliders-h"></i> Filtri
            </button>
            <h4 class="mb-0 font-weight-bold flex-grow-1 text-center">
                Logs
            </h4>
            <div style="width: 80px;"></div>
        </div>
    </div>
    <div class="kt-portlet__head">

        <div v-if="$root.isMobile">
            <div class="offcanvas-backdrop" :class="{ show: showFilters }" @click.self="showFilters = false">

                <aside class="offcanvas-panel" :class="{ open: showFilters }" role="dialog" aria-modal="true">
                    <div class="offcanvas-header" style="background: linear-gradient(135deg, #00802B, #D9CB34);">
                        <h6 class="mb-0 text-light"><i class="fal fa-filter"></i> Filtri ricerca</h6>
                        <button type="button" class="btn btn-light btn-sm" @click="showFilters = false">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>

                    <div class="offcanvas-body">
                        <form class="isprint-filter" autocomplete="off">
                            <div class="row">
                                <div class="form-group mt-1 mr-2 ml-4 float-left">
                                    <label>Id Log</label><br />
                                    <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                                        placeholder="Id Log" type="text" style="width:150px"
                                        v-model="search.ID_LOG.VALUE">
                                </div>
                                <div class="form-group mt-1 mr-2 float-left">
                                    <label>Descrizione</label><br />
                                    <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                                        placeholder="Descrizione del log" type="text" style="width:150px"
                                        v-model="search.DESCRIZIONE.VALUE">
                                </div>
                                <div class="form-group mt-1 mr-2 float-left">
                                    <label>Utente</label><br />
                                    <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                                        placeholder="Username" type="text" style="width:150px"
                                        v-model="search.USERNAME.VALUE">
                                </div>
                                <div class="form-group mt-1 mr-2 float-left">
                                    <label>Data Operazione Da</label><br />
                                    <DatePicker placeholder="Data inizio" autocomplete="off" :dim="'sm'" type="text"
                                        style="width:150px" v-model="search.DATA_OPERAZIONE.VALUE_FROM"></DatePicker>
                                </div>
                                <div class="form-group mt-1 mr-2 float-left">
                                    <label>Data Operazione A</label><br />
                                    <DatePicker placeholder="Data fine" autocomplete="off" :dim="'sm'" type="text"
                                        style="width:150px" v-model="search.DATA_OPERAZIONE.VALUE_TO"></DatePicker>
                                </div>
                                <div class="form-group mt-1 mr-2 float-left">
                                    <label>Ip</label><br />
                                    <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                                        placeholder="Indirizzo Ip" type="text" style="width:150px"
                                        v-model="search.IP.VALUE">
                                </div>
                                <div class="form-group mt-1 mr-2 float-left">
                                    <label>Session Id</label><br />
                                    <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                                        placeholder="Id della sessione" type="text" style="width:150px"
                                        v-model="search.SESSION_ID.VALUE">
                                </div>
                                <div class="form-group mt-1 mr-2 float-left">
                                    <label for="stato">Stato</label><br />
                                    <select class="form-control form-control-sm" v-model="search.ESITO.VALUE" id="stato"
                                        name="stato">
                                        <option value="" selected>Tutti</option>
                                        <option value="0">Successo</option>
                                        <option value="1">Fallito</option>
                                    </select>
                                </div>

                            </div>
                        </form>
                    </div>
                </aside>
            </div>
        </div>
        <form v-else class="isprint-filter" autocomplete="off">
                <div class="form-group">
                    <label>Id Log</label><br />
                    <input class="form-control form-control-sm" autocomplete="off" name="adasd" placeholder="Id Log"
                        type="text" style="width:150px" v-model="search.ID_LOG.VALUE">
                </div>
                <div class="form-group">
                    <label>Descrizione</label><br />
                    <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                        placeholder="Descrizione del log" type="text" style="width:150px"
                        v-model="search.DESCRIZIONE.VALUE">
                </div>
                <div class="form-group">
                    <label>Utente</label><br />
                    <input class="form-control form-control-sm" autocomplete="off" name="adasd" placeholder="Username"
                        type="text" style="width:150px" v-model="search.USERNAME.VALUE">
                </div>
                <div class="form-group">
                    <label>Data Operazione Da</label><br />
                    <DatePicker placeholder="Data inizio" autocomplete="off" :dim="'sm'" type="text" style="width:150px"
                        v-model="search.DATA_OPERAZIONE.VALUE_FROM"></DatePicker>
                </div>
                <div class="form-group">
                    <label>Data Operazione A</label><br />
                    <DatePicker placeholder="Data fine" autocomplete="off" :dim="'sm'" type="text" style="width:150px"
                        v-model="search.DATA_OPERAZIONE.VALUE_TO"></DatePicker>
                </div>
                <div class="form-group">
                    <label>Ip</label><br />
                    <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                        placeholder="Indirizzo Ip" type="text" style="width:150px" v-model="search.IP.VALUE">
                </div>
                <div class="form-group">
                    <label>Session Id</label><br />
                    <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                        placeholder="Id della sessione" type="text" style="width:150px"
                        v-model="search.SESSION_ID.VALUE">
                </div>
                <div class="form-group">
                    <label for="stato">Stato</label><br />
                    <select class="form-control form-control-sm" v-model="search.ESITO.VALUE" id="stato" name="stato">
                        <option value="" selected>Tutti</option>
                        <option value="0">Successo</option>
                        <option value="1">Fallito</option>
                    </select>
                </div>
        </form>
    </div>
    <div class="isprint-grid-container">
        <div v-if="$root.isMobile" class="row justify-content-center">
            <div class="col-12 mb-4" v-for="log in paginatedList.arr" :key="log.ID_LOG">
                <div class="card shadow border-0 text-center p-3" style="border-radius: 20px;">
                    <div class="card-body">
                        <div class="font-weight-bold text-ecomm h4 mb-3">
                            Log #{{ log.ID_LOG }}
                        </div>
                        <div>
                            <p><strong>Descrizione:</strong> {{ log.DESCRIZIONE || 'Nessuna Descrizione' }}</p>
                        </div>
                        <div>
                            <p><strong>Utente:</strong> {{ log.USERNAME }}</p>
                        </div>
                        <div>
                            <p><strong>Data Operazione:</strong> {{ filters.formatDateTime(log.DATA_OPERAZIONE) || '—' }}
                            </p>
                        </div>
                        <div>
                            <p><strong>IP:</strong> {{ log.IP || 'Non disponibile' }}</p>
                        </div>
                        <div>
                            <p><strong>Session ID:</strong> {{ log.SESSION_ID || 'Non disponibile' }}</p>
                        </div>
                        <div>
                            <p>
                                <strong>Stato:</strong><br>
                                <span :class="log.ESITO == 0 ? 'badge badge-success' : 'badge badge-danger'">
                                    {{ log.ESITO == 0 ? 'Successo' : 'Fallito' }}
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <table v-else class="isprint-grid shadow">
            <thead class="isprint-grid-thead">
                <tr style="left: 0px; background: linear-gradient(135deg, #00802B, #D9CB34); color:#fff;">
                    <th style="width:10%"><span>Id</span></th>
                    <th style="width:20%"><span>Descrizione</span></th>
                    <th style="width:20%"><span>Username</span></th>
                    <th style="width:15%"><span>Data Operazione</span></th>
                    <th style="width:10%"><span>Ip</span></th>
                    <th style="width:20%"><span>SessionId</span></th>
                    <th style="width:5%"><span>Stato</span></th>
                </tr>
            </thead>
            <tbody class="isprint-grid-tbody" style="font-size:14px !important">
                <tr style="left: 0px;height:50px" v-for="log in paginatedList.arr" v-bind:key="log.ID_LOG">
                    <td style="width:10%">
                        <kbd style="font-size:16px">{{ log.ID_LOG }}</kbd>
                    </td>
                    <td style="width:20%">
                        <span><strong>{{
                            log.DESCRIZIONE != null ? log.DESCRIZIONE : 'Nessuna Descrizione'
                                }}</strong></span>
                    </td>
                    <td style="width:20%">
                        <i class="fad fa-user fa-2x" style="margin-right: 10px;" aria-hidden="true"></i>
                        <div style="display: inline-block">
                            <div><strong>{{ log.USERNAME }}</strong></div>
                        </div>
                    </td>
                    <td style="width:15%">
                         <i class="fad fa-calendar-day fa-2x mr-2"></i>
                        <strong>{{ filters.formatDateTime(log.DATA_OPERAZIONE) }}</strong>
                    </td>
                    <td style="width:10%">
                        <strong>{{ log.IP }}</strong>
                    </td>
                    <td style="width:20%">
                        <strong>{{ log.SESSION_ID }}</strong>
                    </td>
                    <td style="width:5%">
                        <span :class="log.ESITO == 0 ? 'badge badge-success' : 'badge badge-danger'">
                            {{ log.ESITO == 0 ? 'Successo' : 'Fallito' }}
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
        <Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count"
            :numpagine="search.PAGINATION.LENGTH"></Pagine>
    </div>


</template>

<script>
import Pagine from '@/components/utils/Pagine.vue'
import DatePicker from '@/components/utils/DatePicker.vue'

export default {
    name: "DcpLogs",
    components: {
        Pagine,
        DatePicker,
    },
    data: function () {
        return {
            filters: global.filters,
            search: {
                PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 50 },
                USERNAME: { TYPE: 'TEXT', VALUE: '' },
                DESCRIZIONE: { TYPE: 'TEXT', VALUE: '' },
                DATA_OPERAZIONE: { TYPE: 'DATE_RANGE', VALUE_FROM: '', VALUE_TO: '' },
                SESSION_ID: { TYPE: 'TEXT', VALUE: '' },
                ESITO: { TYPE: 'COMBO', VALUE: '' },
                IP: { TYPE: 'TEXT', VALUE: '' },
                ID_LOG: { TYPE: 'TEXT', VALUE: '' },
            },
            arrayLogs: new Array(),
            showFilters: false,
        }
    },
    methods: {
        getLogs: function () {
            global.utils.get('/dcp/logs', {}, (response) => {
                this.arrayLogs = response.data;
            });
        },
    },
    computed: {
        paginatedList() {
            var arr = utils.inGrid(this.arrayLogs, this.search);
            return arr;
        },
    },
    created: function () {
        this.getLogs();
    },
}
</script>
<style>
.offcanvas-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, .15);
    opacity: 0;
    visibility: hidden;
    transition: opacity .2s ease, visibility .2s ease;
    z-index: 1040;
}

.offcanvas-backdrop.show {
    opacity: 1;
    visibility: visible;
}

.offcanvas-panel {
    position: fixed;
    top: 0;
    right: -100%;
    height: 100vh;
    /* tutta l'altezza dello schermo */
    width: 88%;
    max-width: 420px;
    background: #fff;
    box-shadow: -6px 0 24px rgba(0, 0, 0, .15);
    z-index: 1050;
    display: flex;
    flex-direction: column;
    /* verticale */
    transition: right .25s ease;
    border-top-left-radius: 14px;
    border-bottom-left-radius: 14px;
}

.offcanvas-panel.open {
    right: 0;
}

.offcanvas-header {
    display: flex;
    justify-content: space-between;
    /* spinge titolo a sinistra e bottone a destra */
    align-items: center;
    /* centra verticalmente */
    padding: .75rem 1rem;
    border-bottom: 1px solid #eee;
}

.offcanvas-body {
    flex: 1;
    /* si espande sul resto */
    padding: 1rem;
    overflow-y: auto;
    /* scroll se serve */
}

@media (min-width: 1282px) {
  .isprint-grid-container {
    margin-top: 20px;
    width: auto;
    table-layout: auto;
  }
}

/* Quando la larghezza della finestra è inferiore a 1536px */
@media (max-width: 1281px) {
  .isprint-grid-container {
    margin-top: 100px;
  }
}

.mobile-page-title {
    padding: 15px;
    background: linear-gradient(135deg, #00802B, #D9CB34);
    color: white;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    position: sticky;
    top: 0;
    z-index: 100;
}

.mobile-page-title h4 {
    margin: 0;
    color: white;
}

.mobile-page-title i {
    margin-right: 8px;
}

/* Nascondi il portlet head in mobile visto che è vuoto */
@media (max-width: 767px) {
    .kt-portlet__head {
        height: 0 !important;
        overflow: hidden;
    }
}
</style>
